import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./pagination.html';
import controller from './Pagination';
import styles from './pagination_hashed.scss';

/**
 * @ngdoc component
 * @name edge.gateway.contacts.common.app.component: gwContactsPagination
 *
 * @description  A pagination component displaying a label with the current pagination position and two buttons to
 * move to the next and previous pages.
 *
 * @param label {string} key to the literal used to display the pagination position. This literal can use
 * three parameters.
 *   start: the 0-based index of the first item displayed
 *   end: the 0-based index of the last item displayed
 *   total: the total number of items we are paginating on
 * @param currentPage: {number} the 0-based index of the current page.
 * @param totalItems: {number} the total number of items.
 * @param pageSize: {number} the size of each page.
 * @param onPageChange: {expression} expression to evaluate when the user moves to another page. The target page is
 * available as 'toPage', and the current page size as 'pageSize'
 *
 */
export default {
    controller,
    template: cssUtil.hashTemplate(template, styles),
    bindings: {
        label: '@',
        currentPage: '<',
        totalItems: '<',
        pageSize: '<',
        onPageChange: '&'
    }
};
